import { RouteType } from '@/Routes';
import { lazy } from 'react';

const MyPage = lazy(() => import('@/pages/mypage'));
const MyPageKeiji = lazy(() => import('@/pages/mypage/keijis'));
const MyPagePurchaseHistory = lazy(
  () => import('@/pages/mypage/purchase_histories')
);

const ServerMyPage: RouteType[] = [
  {
    path: '/mypage',
    title: 'マイページ',
    component: MyPage,
  },
  {
    path: '/mypage/keijis',
    title: '掲示板の管理',
    component: MyPageKeiji,
  },
  {
    path: '/mypage/purchase_histories',
    title: '購入履歴・領収書発行',
    component: MyPagePurchaseHistory,
  },
].map((item) => {
  return { ...item, requireAuth: true };
});

export default ServerMyPage;
